<!-- <div class="message d-flex flex-row align-items-center justify-content-around"> -->
<mat-card class="welcome-card">
  <div>
    <img src="/assets/images/logo.png" alt="Welcome Logo" class="welcome-logo"/>
    <h1>Welcome to the Supportis Client Portal</h1>
    <button mat-button color="primary" (click)="redirectToDashboard()">Click Here to Continue to Your Dashboard</button>
  </div>
</mat-card>